import { eAnimAssets } from "../../Game";
import { TIMER } from "../Gameplay";
import { Goalie } from "./Goalie";

export class AnimSideStep {
    /**
     * Rychlost presunu do strany v metrech za vterinu
     */
    static readonly SPEED = 4;
    /**
     * Delka animace ve vterinach
     */
    static readonly ANIM_LEN = 17 / 30;

    private _goalie: Goalie;

    /**
     * Cas, kdy ma dojit k zahajeni posunu
     */
    private _startTime: number;
    /**
     * Cas, kdy bude dosazeno cilove pozice
     */
    private _endTime: number;

    private _startPos: number;
    private _endPos: number;

    private static readonly FLAG_ACTIVE = 1;
    private static readonly FLAG_WAIT_FOR_START = 2;

    private _flags: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(goalie: Goalie) {
        this._goalie = goalie;
    }

    //-------------------------------------------------------------------------
    /**
     * Inicializace animace pro posun brankare do strany po zemi
     * @param distance Vzdalenost, o kterou ma byt brankar posunut
     * @param endTime Cas, kdy ma byt posun dokoncen
     */
    //-------------------------------------------------------------------------
    init(distance: number, endTime: number): void {
        this._startPos = this._goalie.entity.getPosition().x;
        this._endTime = endTime;

        let reqTime = (Math.abs(distance) / AnimSideStep.SPEED) * 1000;
        let time = endTime - TIMER.time;

        if (reqTime < time) {
            this._endPos = this._startPos + distance;
            this._startTime = this._endTime - reqTime;
        }
        else {
            // Neni dostatek casu na presun o pozadovanou vzdalenost
            let dis = (time / 1000) * AnimSideStep.SPEED;

            this._endPos = this._startPos + (dis * (distance < 0 ? -1 : 1));
            this._startTime = this._endTime - (dis / AnimSideStep.SPEED) * 1000;
        }

        this._flags = AnimSideStep.FLAG_ACTIVE | AnimSideStep.FLAG_WAIT_FOR_START;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._flags = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if ((this._flags & AnimSideStep.FLAG_ACTIVE) == 0 || TIMER.time < this._startTime)
            return;

        if ((this._flags & AnimSideStep.FLAG_WAIT_FOR_START) != 0) {
            if (TIMER.time < this._startTime)
                return;

            this._flags &= ~AnimSideStep.FLAG_WAIT_FOR_START;
            this._goalie.startAnimation(eAnimAssets.goalieSideStep, 0.1, true, 1);
        }

        let progress = (TIMER.time - this._startTime) / (this._endTime - this._startTime);

        if (progress >= 1) {
            progress = 1;
            this._flags &= ~AnimSideStep.FLAG_ACTIVE;
        }

        let pos = this._goalie.entity.getPosition();

        pos.x = this._startPos + (this._endPos - this._startPos) * progress;
        this._goalie.entity.setPosition(pos);
    }
}